const inClientSide = () => {
  return typeof window !== "undefined";
};
export {
  inClientSide
};
//# sourceMappingURL=ssr.js.map